import { render, staticRenderFns } from "./terms-preview.vue?vue&type=template&id=2c6b75ba&scoped=true&"
import script from "./terms-preview.vue?vue&type=script&lang=js&"
export * from "./terms-preview.vue?vue&type=script&lang=js&"
import style0 from "./terms-preview.vue?vue&type=style&index=0&id=2c6b75ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6b75ba",
  null
  
)

export default component.exports